// @ts-strict-ignore
import { Action, Question } from '../triage-module'
import { Controller } from '@hotwired/stimulus'
import { trackComponent } from 'critical/tracking'

// TODO look at whether we can add stimulus to storybook
export default class extends Controller {
  static targets = ['question', 'main']

  static values = { componentId: String, contentfulName: String }

  unpickAnswers(selectedQ: Node) {
    const listItem = selectedQ.parentElement
    const section = listItem?.parentElement

    if (section && section.hasChildNodes()) {
      const children = section.childNodes

      for (const node of children) {
        if (!node.isEqualNode(listItem)) {
          node.classList.add('unselected')
        }
      }
    }
  }

  addActionLinks(action: Action) {
    const section = document.createElement('section')
    section.classList.add('Triage__action')

    const title = document.createElement('h3')
    title.classList.add('Triage__qa__ctaText')
    title.textContent = action.text
    section.appendChild(title)

    if (action.description) {
      const description = document.createElement('div')
      description.classList.add('Triage__qa__description')
      description.textContent = action.description
      section.appendChild(description)
    }

    const links = action.links ?? []

    if (links.length > 0) {
      const linkSection = document.createElement('section')
      linkSection.classList.add('Triage__action__links')
      links.forEach((l) => {
        const ctaLink = document.createElement('a')
        ctaLink.classList.add('Triage__action__links__link')
        ctaLink.href = l.href
        ctaLink.target = '_blank'
        ctaLink?.addEventListener('click', () => {
          /* eslint-disable camelcase */
          const additionalProps = { href: l.href, text: l.text }
          const componentData = {
            component_category: 'platinum-component',
            component_id: this.componentIdValue,
            component_name: 'Triage',
            contentful_name: this.contentfulNameValue,
            contentful_variant: 'triage-module',
          }
          trackComponent('Dynamic Component Event', 'CTAButtonClicked', componentData, {
            ...additionalProps,
          })
        })

        const ctaButton = document.createElement('button')
        ctaButton.classList.add('button_atom', 'button_atom__primary', 'button_atom__mdTriage')
        ctaButton.textContent = l.text

        ctaLink.appendChild(ctaButton)
        linkSection.appendChild(ctaLink)
      })
      section.appendChild(linkSection)
    }

    this.mainTarget.append(section)
  }

  addQuestion(nextq: Question) {
    const section = document.createElement('section')
    section.classList.add('Triage__qa')
    section.style.opacity = '0'
    section.dataset.triageTarget = 'question'
    section.dataset.triageIdValue = String(nextq.id)

    const title = document.createElement('h3')
    title.classList.add('Triage__qa__question')
    title.textContent = nextq.question

    let description
    if (nextq.description) {
      description = document.createElement('div')
      description.classList.add('Triage__qa__description')
      description.textContent = nextq.description
    }

    const answerList = document.createElement('ul')
    answerList.classList.add('Triage__qa__answers')

    const answers = nextq.answers || []

    answers.forEach((a) => {
      const item = document.createElement('li')
      item.classList.add('Triage__qa__answers__answer')
      const button = document.createElement('button')
      item.dataset.triageNextqParam = JSON.stringify(a.nextQuestion || null)
      item.dataset.triageActionParam = JSON.stringify(a.action || null)
      item.dataset.action = 'click->triage#answer'
      item.dataset.triageQidParam = String(nextq.id)
      button?.addEventListener('click', () => {
        /* eslint-disable camelcase */
        const additionalProps = { question: nextq.question, answer: a.text }
        const componentData = {
          component_category: 'platinum-component',
          component_id: this.componentIdValue,
          component_name: 'Triage',
          contentful_name: this.contentfulNameValue,
          contentful_variant: 'triage-module',
        }
        trackComponent('Dynamic Component Event', 'CTAButtonClicked', componentData, {
          ...additionalProps,
        })
      })

      button.classList.add(
        'animated',
        'button_atom',
        'button_atom__secondary',
        'button_atom__mdTriage',
      )
      button.textContent = a.text
      item.appendChild(button)

      answerList.appendChild(item)
    })

    section.appendChild(title)
    description && section.appendChild(description)
    section.appendChild(answerList)
    this.mainTarget.append(section)
  }

  resetQuestions(qid: number) {
    const clicked = this.questionTargets.find((q) => parseInt(q.dataset.triageIdValue) === qid)

    const answers = clicked.querySelectorAll('.Triage__qa__answers__answer')
    for (const answer of answers) {
      answer.classList.remove('unselected')
    }

    while (clicked.nextSibling) {
      clicked.parentElement.removeChild(clicked.nextSibling)
    }
  }

  answer(args: any) {
    const nodeItself = args.target
    const { qid, action, nextq } = args.params
    this.resetQuestions(qid)
    this.unpickAnswers(nodeItself)
    if (args.params.action) {
      this.addActionLinks(action)
    } else if (nextq) {
      this.addQuestion(args.params.nextq)
    }
  }

  initialize(): void {
    const existingButtons = this.questionTarget.querySelectorAll(
      '.Triage__qa__answers__answer > button',
    )
    existingButtons.forEach((b) => b.classList.add('animated'))
  }
}
